// frontend/src/components/ToggleOverlay.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { FaChevronUp, FaChevronDown, FaTimes } from 'react-icons/fa';
import '../styles/ToggleOverlay.css';

const ToggleOverlay = ({
  title,
  icon: Icon,
  isCollapsed,
  onCollapse,
  onClose,
  className,
  children,
  width = 400,
}) => {
  return (
    <div
      className={`toggle-overlay ${isCollapsed ? 'collapsed' : ''} ${className || ''}`}
      style={{ width: `${width}px` }}
    >
      <div className="toggle-overlay-header">
        <div className="toggle-overlay-title">
          {Icon && <Icon className="overlay-icon" onClick={onClose} />}
          <h3>{title}</h3>
        </div>
        <div className="header-buttons">
          <button
            className="collapse-button"
            onClick={onCollapse}
            aria-label={isCollapsed ? "Expand overlay" : "Collapse overlay"}
            title={isCollapsed ? "Expand" : "Collapse"}
          >
            {isCollapsed ? <FaChevronDown /> : <FaChevronUp />}
          </button>
          <button
            className="close-button"
            onClick={onClose}
            aria-label="Close overlay"
            title="Close"
          >
            <FaTimes />
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div className="toggle-overlay-content">
          {children}
        </div>
      )}
    </div>
  );
};

ToggleOverlay.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  isCollapsed: PropTypes.bool,
  onCollapse: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
};

export default ToggleOverlay;
